<template lang="pug">
.manager-layout(v-if="logged")
  .header-container
    .content-container
      .user-info
        el-avatar(:size="64" icon="el-icon-user-solid")
        .user-data
          .nickname {{ userInfo.nickname }}
          .account  {{ userInfo.mobile }}
        .user-static
          .user-static-item
            .label 认证情况：
            .value 实名认证
          .user-static-item
            .label 上次登录时间：
            .value {{ lastLoginTime }}
          //.user-static-item
          //  .label 认证入住企业：
          //  .value 未认证
          //.user-static-item
          //  .label 服务商认证：
          //  .value 未认证
      .button-logout(@click="handleLogout") 退出登录
  .main-container
    .content-container
      .aside
        .menu
          .menu-item(v-for="nav in menu" :key="nav.name"
            :class="{'active': menuItemStatus(nav)}"
            @click="handleMenuItemClick(nav)")
            img(:src="menuItemIcon(nav)")
            span {{ nav.meta.nameCN }}
      .main
        template
          keep-alive
            router-view
el-result(v-else icon="error" title="无权访问" subTitle="请根据提示进行操作")
  template(slot="extra")
    el-button(type="primary" size="medium" @click="toPortal") 返回门户
</template>

<script>
import ManagerRoute from "@/router/manager.route";
import {mapGetters, mapMutations} from "vuex";
import moment from 'moment';

export default {
  name: "ManagerLayout",
  computed: {
    ...mapGetters({
      logged: 'auth/logged',
      userInfo: 'auth/userInfo',
    }),
    menu() {
      return ManagerRoute.filter(item => item.meta.showInNav);
    },
    menuItemIcon() {
      return nav => require(`@/assets/manager/icon-${nav.meta.icon}.svg`);
    },
    menuItemStatus() {
      return nav => this.$route.path.includes(nav.path);
    },
    lastLoginTime() {
      return moment(this.userInfo.last_login_time * 1000).format('YYYY-MM-DD');
    }
  },
  methods: {
    ...mapMutations({
      clearToken: 'auth/CLEAR_TOKEN',
      clearUserInfo: 'auth/CLEAR_USER_INFO',
    }),
    handleMenuItemClick(nav) {
      this.$router.push(nav);
    },
    handleLogout() {
      this.$confirm('确定退出登录？', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        this.clearToken();
        this.clearUserInfo();
        this.$router.replace({
          name: 'portalHome'
        });
      });
    },
    toPortal() {
      this.$router.replace({
        name: 'portalHome',
      })
    }
  }
}
</script>

<style lang="scss" scoped>
.manager-layout{
  display: flex;
  flex-direction: column;
  .header-container{
    height: 190px;
    background: #006A28;
    .content-container{
      height: 100%;
      display: flex;
      align-items: center;
      justify-content: space-between;
      .user-info{
        display: flex;
        align-items: center;
        margin-right: 115px;
        .user-data{
          padding-left: 24px;
          .nickname{
            font-weight: 700;
            font-size: 16px;
            color: #FFFFFF;
          }
          .account{
            font-weight: 700;
            font-size: 12px;
            color: rgba(255, 255, 255, 0.5);
          }
        }
        .user-static{
          display: flex;
          .user-static-item{
            padding: 0 32px;
            font-size: 12px;
            position: relative;
            .label{
              color: rgba(255, 255, 255, 0.8);
              margin-bottom: 4px;
            }
            .value{
              color: #FFFFFF;
            }
            & + .user-static-item{
              &:before{
                content: '';
                display: block;
                width: 1px;
                height: 25px;
                background-color: rgba(255, 255, 255, 0.5);
                position: absolute;
                left: 0;
                top: 50%;
                transform: translateY(-50%);
              }
            }
          }
        }
      }
      .button-logout{
        width: 96px;
        height: 32px;
        line-height: 32px;
        text-align: center;
        background: #FFFFFF;
        font-weight: 700;
        font-size: 12px;
        color: #007739;
        @extend .finger;
      }
    }
  }
  .main-container{
    position: relative;
    background: #E5E5E5;
    padding-bottom: 25px;
    &:before{
      content: '';
      display: block;
      background: #006A28;
      height: 70px;
      width: 100%;
      position: absolute;
    }
    .content-container{
      display: flex;
      justify-content: space-between;
      position: relative;
      .aside{
        flex: 0 0 308px;
        width: 308px;
        background-color: white;
        .menu{
          padding: 32px 24px;
          .menu-item{
            height: 48px;
            display: flex;
            align-items: center;
            padding-left: 16px;
            font-size: 14px;
            color: rgba(0, 0, 0, 0.67);
            @extend .finger;
            &.active{
              background: rgba(46, 186, 34, 0.1);
            }
            img{
              margin-right: 8px;
            }
            & + .menu-item{
              margin-top: 24px;
            }
          }
        }
      }
      .main{
        flex: 1;
        background-color: white;
        margin-left: 16px;
      }
    }
  }
}
</style>
